<script>
  // # # # # # # # # # # # # #
  //
  //  Navigation (desktop)
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { Router, links } from 'svelte-routing'

  // *** STORES
  import { intro, feedActive, bgColor } from '../stores.js'

  // COMPONENTS
  import Logo from './Logo.svelte'

  // *** VARIABLES
  let shown = true
  let open = false
  let gallery = false
  let architecture = false

  // *** FUNCTIONS
  function scrollToTop() {
    open = false
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }
</script>

<style lang="scss">
  @import '../_variables.scss';
  .menu {
    $block: &;

    width: 100vw;
    height: $menu-height;
    padding-bottom: 40px;
    z-index: 1000;
    overflow: hidden;
    padding-left: 0;
    margin-top: 0;
    font-size: $font-size-large;
    font-family: $sans-stack;

    user-select: none;
    background-color: transparent;

    @include screen-size('small') {
      height: 80px;
    }

    &--top {
      position: fixed;
      top: 0;
      left: 0;
    }

    &--bottom {
      position: fixed;
      bottom: 0;
      left: 0;
    }

    transition: opacity $slow-easing;
    opacity: 0;

    &__item {
      span,
      a {
        cursor: pointer;
        color: currentColor;
        color: white;
        border-bottom: none;
        @include normal-hover-state;
      }

      @include screen-size('small') {
        display: none;
      }
    }

    &__body {
      margin-top: 0px;
      width: 33.33%;
      height: 100%;
      float: left;
      font-family: $serif-stack;
      opacity: 0;
      transition: opacity $fast-easing;
      display: block;

      &--left {
        text-align: left;
        padding-left: $main-margin;
      }

      &--center {
        text-align: center;
        height: 100%;
      }
      &--right {
        text-align: right;
        padding-right: $main-margin;
      }
    }

    &__section {
      float: left;
      height: 70px;
      line-height: 65px;
      width: 33.33%;

      &--left {
        text-align: left;
        padding-left: $main-margin;
      }

      &--center {
        text-align: center;
        cursor: pointer;

        &.logo {
          margin-top: 10px;
          height: 48px;
        }

        &.text {
          margin-top: 0;
          height: 70px;
        }
      }

      &--right {
        text-align: right;
        padding-right: $main-margin;
      }
    }

    &.shown {
      transition: opacity $slow-easing;
      opacity: 1;
    }

    &.open {
      height: 160px;
      opacity: 1;

      #{ $block }__body {
        opacity: 1;
        transition: opacity $fast-easing;
      }
    }
    mix-blend-mode: difference;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: $white;
    opacity: 0;
    pointer-events: none;
    z-index: 500;

    &.active {
      transition: opacity $slow-easing;
      opacity: 0.8;
      pointer-events: all;
    }
  }

  .disabled {
    color: $grey !important;
    pointer-events: none;
  }
</style>

<Router>
  <!-- {# TOP MENU BAR #} -->
  <nav
    class="menu menu--top"
    class:shown={!$intro}
    class:open
    class:light={$bgColor == 'light'}
    class:dark={$bgColor == 'dark'}
    use:links>

    <!-- {# LEFT: header #} -->
    <div class="menu__section menu__section--left" class:active={architecture}>
      <div class="menu__item">
        <span
          class="menu__toggle"
          on:click={() => {
            open = !open
          }}>
          Architecture
        </span>
      </div>
    </div>

    <!-- {# CENTER: header #} -->
    <div class="menu__section menu__section--center logo">
      <a href="/" class="menu__item" on:click={scrollToTop}>
        <Logo />
      </a>
    </div>

    <!-- {# RIGHT: header #} -->
    <div class="menu__section menu__section--right" class:active={gallery}>
      <div class="menu__item">
        <span
          class="menu__toggle"
          on:click={() => {
            open = !open
          }}>
          Gallery
        </span>
      </div>
    </div>

    <!-- {# LEFT: body #} -->
    <div class="menu__body menu__body--left" class:active={architecture}>

      <div class="menu__item">
        <a
          href="/architecture/projects"
          on:click={() => {
            open = false
          }}>
          Projects
        </a>
      </div>

      <div class="menu__item">
        <a
          href="/architecture/brands"
          on:click={() => {
            open = false
          }}>
          Brands
        </a>
      </div>

    </div>

    <!-- {# CENTER: body #} -->
    <div class="menu__body menu__body--center menu__body--center" />

    <!-- {# RIGHT: body #} -->
    <div class="menu__body menu__body--right" class:active={gallery}>

      <div class="menu__item">
        <a
          href="/gallery/exhibitions"
          on:click={() => {
            open = false
          }}>
          Exhibitions
        </a>
      </div>

      <div class="menu__item">
        <a
          href="/gallery/artists"
          on:click={() => {
            open = false
          }}>
          Artists
        </a>
      </div>

    </div>

  </nav>

  <!-- {# BOTTOM MENU BAR #} -->
  <nav class="menu menu--bottom" class:shown={!$intro} use:links>
    <!-- {# LEFT: header #} -->
    <div class="menu__section menu__section--left">
      <div class="menu__item">
        <a
          href="/about"
          on:click={() => {
            open = false
          }}>
          About
        </a>
      </div>
    </div>

    <!-- {# CENTER: header #} -->
    <div class="menu__section menu__section--center text">
      <div class="menu__item">
        <a
          href="/tags"
          on:click={() => {
            open = false
          }}>
          Tags
        </a>
      </div>
    </div>

    <!-- {# RIGHT: header #} -->
    <div class="menu__section menu__section--right">
      <div class="menu__item">
        <a
          href="/contact"
          on:click={() => {
            open = false
          }}>
          Contact
        </a>
      </div>
    </div>

  </nav>

</Router>

<!-- {# OVERLA\Y #} -->
<div
  class="overlay"
  class:active={open}
  on:click={() => {
    open = false
  }} />
